import { Box, Flex, Text } from '@chakra-ui/react';

type Size = 'xs' | 'sm' | 'md' | 'lg';
type Palette = 'accent' | 'primary' | 'success' | 'warning' | 'error';

const HEIGHTS: Record<Size, string> = { xs: '2px', sm: '4px', md: '6px', lg: '8px' };
const COLORS: Record<Palette, string> = {
  accent: 'figma.accent',
  primary: 'figma.primary',
  success: 'figma.success',
  warning: 'figma.warning',
  error: 'figma.error',
};

export interface ProgressProps {
  value?: number;
  size?: Size;
  colorPalette?: Palette;
}

/** Figma-styled progress bar. */
export function Progress({ value = 0, size = 'sm', colorPalette = 'accent' }: ProgressProps) {
  return (
    <Box w="full" h={HEIGHTS[size]} bg="figma.border" borderRadius="full" overflow="hidden">
      <Box
        h="full"
        bg={COLORS[colorPalette]}
        borderRadius="full"
        transition="width 0.3s ease"
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </Box>
  );
}

export interface ProgressWithLabelProps extends ProgressProps {
  label?: string;
  showPercent?: boolean;
}

/** Progress bar with a label row and optional percentage. */
export function ProgressWithLabel({
  value = 0,
  label,
  size = 'sm',
  colorPalette = 'accent',
  showPercent = true,
}: ProgressWithLabelProps) {
  return (
    <Box w="full">
      {label && (
        <Flex justify="space-between" align="center" mb="1">
          <Text fontSize="xs" color="figma.textSecondary">
            {label}
          </Text>
          {showPercent && (
            <Text fontSize="xs" color="figma.textMuted" fontFamily="mono">
              {Math.round(value)}%
            </Text>
          )}
        </Flex>
      )}
      <Progress value={value} size={size} colorPalette={colorPalette} />
    </Box>
  );
}
